import "./Payments.scss";
import Sidebar from "@/components/Sidebar/Sidebar";
import Header from "@/components/Tax Pro Only/Header/Header";
import { AppShell, Burger, MantineProvider, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Notifications } from "@mantine/notifications";
import TaxProPayments from "./TaxProPaymentRequests/TaxProPayments";
import { useAuthStore } from "@utils/stores/authStore.ts";

const Payments: React.FC = () => {
  const [opened, { toggle }] = useDisclosure();
  const { role } = useAuthStore();
  return (
    <MantineProvider>
      <Notifications />
      <AppShell
        className="home home-page"
        header={{ height: 87 }}
        navbar={{
          width: "15.375rem",
          breakpoint: "sm",
          collapsed: { mobile: !opened },
        }}
        padding="md"
      >
        <AppShell.Header className="app-header">
          <Burger
            className="burger"
            opened={opened}
            onClick={toggle}
            hiddenFrom="sm"
            size="sm"
          />
          <Header />
        </AppShell.Header>
        <AppShell.Navbar className="nav">
          <Sidebar />
        </AppShell.Navbar>
        <AppShell.Main className="main-container">
          <div className="payment-title">
            <div className="payments-title-container">
              <h2 className="payments-title">Payments</h2>
              {role === "owner" ? (
                <Text c="dimmed">
                  Easily request, track, and manage client payments.
                </Text>
              ) : null}
            </div>
          </div>
          <div className="payments-container">
            <TaxProPayments />
          </div>
        </AppShell.Main>
      </AppShell>
    </MantineProvider>
  );
};

export default Payments;
